import React from 'react';

export const CustomerPagesConfig = [
  {
    auth: ['superadmin'],
    routes: [
      {
        path: '/Customer/overview/:page',
        component: React.lazy(() => import('./Pages/overview')),
      },
    ],
  },
  {
    auth: ['superadmin'],
    routes: [
      {
        path: '/Customer/Detail/:id',
        component: React.lazy(() => import('./Pages/Detail')),
      },
    ],
  },
  {
    auth: ['superadmin'],
    routes: [
      {
        path: '/Customer/Delete/:page/:deleteID',
        component: React.lazy(() => import('./Pages/overview')),
      },
    ],
  },
  {
    auth: ['superadmin'],
    routes: [
      {
        path: '/Customer/new/',
        component: React.lazy(() => import('./Pages/new')),
      },
    ],
  },
];
